// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6c2c8d35","977":"311b9699"}[chunkId] + ".chunk.js";
};